import { Col, FormModal, Row, Typography } from 'components';
import React from 'react';
import { useMarkNotAvailableModal } from 'feature/purchaseRequestTabs/supplierOffers/edit/markNotAvailable/useMarkNotAvailableModal';

const { Text, Title } = Typography;

export interface IMarkNotAvailableModel {
  onCancel: () => void;
  open: boolean;
  record?: Record<string, any>;
  originalItemId?: string;
}

export const MarkNotAvailableModel = React.memo((props: IMarkNotAvailableModel) => {
  const { onCancel, open, originalItemId, record } = props;
  const { form, onFinish, isLoading, onModalCancel } = useMarkNotAvailableModal({
    originalItemId,
    onCancel,
    type: record?.itemActionType,
  });
  return (
    <FormModal
      form={form}
      okText={'Confirm'}
      width={360}
      open={open}
      disableOkBtn={false}
      isLoading={isLoading}
      onCancel={onModalCancel}
      onSubmit={onFinish}
    >
      <Row className={'margin-t-20'}>
        <Col span={24}>
          <Row gutter={[0, 12]} align={'middle'} justify={'center'}>
            <Col>{/*<AlternativeIconBig />*/}</Col>
            <Col span={24}>
              <Title level={4} className={'reset-title center'}>
                {record?.itemActionType === 'NOT_AVAILABLE' ? 'Mark as Available' : 'Mark as Not Available'}
              </Title>
            </Col>
            <Col span={24} className={'center'}>
              <Text type={'secondary'} className={'center'}>
                Are you sure you want to
                {record?.itemActionType === 'NOT_AVAILABLE' ? 'Mark as Available' : 'Mark as Not Available'} this item?
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </FormModal>
  );
});
